import { render, staticRenderFns } from "./InvoiceOrderAllowanceCharge.vue?vue&type=template&id=66772435&scoped=true&"
import script from "./InvoiceOrderAllowanceCharge.vue?vue&type=script&lang=ts&"
export * from "./InvoiceOrderAllowanceCharge.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceOrderAllowanceCharge.vue?vue&type=style&index=0&id=66772435&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66772435",
  null
  
)

export default component.exports